import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import 'react-phone-number-input/style.css'
import PhoneInput from "react-phone-number-input";

export const PhoneInputNumber = ({ ...props }) => {
    const { setFieldValue, values } = useFormikContext();
    const [field] = useField(props);
    const [value, setValue] = useState()

    const onInputChange = (value) => {
        var getValue = document.getElementsByName('phoneCountry')[0];
        setFieldValue("country",getValue.options[getValue.selectedIndex].value)
        setFieldValue(field.name,value)
      }
    return (
        <PhoneInput
            maxlength='20'
            international
            countryCallingCodeEditable={false}
            defaultCountry={values?.country?values?.country:"IN"}
            name={field.name}
            value={field.value}
            onChange={onInputChange} 
            className={`form-control ${props?.disabled?"disableInput":""}`}
            // disabled={props?.disabled?true:false}
        />
    );
};

export default PhoneInputNumber;
